export const KINDS = {
  ZONE: 'zone',
  LITERAL: 'literal',
  DELIMITER: 'delimiter',
  BREAK: 'break',
};

export const isZone = (entry) => entry?.kind === KINDS.ZONE;
export const isLiteral = (entry) => entry?.kind === KINDS.LITERAL;
export const isDelimiter = (entry) => entry?.kind === KINDS.DELIMITER;
export const isRowBreak = (entry) => entry?.kind === KINDS.BREAK;

export function zoneCapacity(zone) {
  const parsedCapacity = Number(zone?.capacity);
  return Number.isFinite(parsedCapacity) && parsedCapacity > 0 ? parsedCapacity : Infinity;
}
